import { useMemo } from "react";
import { useSelector } from "react-redux";
import LoyaltyProgressRankDetail from "components/organisms/LoyaltyProgressRankDetail";
import { useLoyaltyStore } from "stores/loyalty";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { currentCurrency } from "redux/user/selectors";
import { RANK_LEVEL_LOYALTY_IMAGES } from "constants/loyalty";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { useGetRewardsInfo } from "queries/useGetRewardsInfo";
import { useGetLoyaltyRewardsUser } from "queries/useGetLoyaltyRewardsUser";
import {
  formatDataProgressLoyaltyRanks,
  getIdsRewardsOnRank,
} from "utils/loyalty";
import useTranslate from "hooks/useTranslate";

const LoyaltyProgressRankDetailContainer = () => {
  const t = useTranslate();
  const { data: userLoyalty } = useGetLoyaltyUser();
  const { data: progressUser } = useGetProgressLoyalty();
  const activeIndexRank = useLoyaltyStore((state) => state.indexActiveRank);
  const loyalty = userLoyalty?.data?.data;
  const activeRank = loyalty?.settings.ranks[activeIndexRank];
  const currencyCode = useSelector(currentCurrency);
  const { userRewards } = useGetLoyaltyRewardsUser({ loyaltyId: loyalty?.id });
  const ids = getIdsRewardsOnRank(userLoyalty?.data?.data, currencyCode);
  const { rewardsInfo } = useGetRewardsInfo(ids);
  const userExperience = progressUser?.data?.data?.experience || 0;
  const ranks = useMemo(
    () =>
      formatDataProgressLoyaltyRanks({
        t,
        loyalty,
        userExperience,
        userRewards,
        infoRewards: rewardsInfo,
        currencyCode,
      }),
    [loyalty, rewardsInfo, userExperience, userRewards, currencyCode, t],
  );

  const status =
    // eslint-disable-next-line no-nested-ternary
    ranks?.[activeIndexRank]?.rewards?.every((rew) => !rew.isClose)
      ? "complete"
      : ranks?.[activeIndexRank]?.rewards?.some((rew) => !rew.isClose)
        ? "progress"
        : "close";

  return (
    <LoyaltyProgressRankDetail
      rank={activeRank}
      rewardsRankStatus={ranks[activeIndexRank]?.statusRank}
      rewardsRank={ranks[activeIndexRank]?.rewards}
      statusProgress={status}
      rewardsLevels={ranks[activeIndexRank]?.levels}
      image={RANK_LEVEL_LOYALTY_IMAGES[activeIndexRank]?.rank}
    />
  );
};

export default LoyaltyProgressRankDetailContainer;
